import { useTranslation } from "react-i18next";
import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { HiX } from "react-icons/hi";
import { HiCheckCircle } from "react-icons/hi2";

const BulkActionsBar = ({
    selectedCount,
    totalCount,
    isAllSelected,
    totalPages,
    onSelectAll,
    onDeselectAll,
    onChangeStatus,
    onExport,
    onSendEmail,
    isXlsxLoading,
    isSelectAllLoading,
}) => {
    const { t } = useTranslation("models");

    return (
        <Box
            position="fixed"
            bottom={4}
            left={{ base: 4, md: "276px" }}
            right={4}
            zIndex={50}
            bg="bg.card"
            border="1px solid"
            borderColor="brand.400"
            borderRadius={10}
            px={4}
            py={3}
        >
            <HStack justify="space-between" flexWrap="wrap" gap={2}>
                <HStack gap={3} flexWrap="wrap">
                    <HStack gap={2}>
                        <HiCheckCircle color="var(--chakra-colors-brand-400)" size={18} />
                        <Text color="white" fontSize="sm" fontWeight={600}>
                            {t("candidatePage.bulkBar", { count: selectedCount })}
                        </Text>
                    </HStack>
                    {isAllSelected && totalPages > 1 && (
                        <Button
                            variant="ghost"
                            size="xs"
                            color="brand.400"
                            loading={isSelectAllLoading}
                            onClick={onSelectAll}
                        >
                            {t("candidatePage.bulkSelectAll", { count: totalCount })}
                        </Button>
                    )}
                    <Button
                        variant="ghost"
                        size="xs"
                        color="text.grey"
                        onClick={onDeselectAll}
                    >
                        <HiX />
                        {t("candidatePage.bulkDeselectAll")}
                    </Button>
                </HStack>
                <HStack gap={2} flexWrap="wrap">
                    <Button variant="outlined" size="sm" onClick={onChangeStatus}>
                        {t("candidatePage.bulkChangeStatus")}
                    </Button>
                    <Button variant="outlined" size="sm" onClick={onSendEmail}>
                        {t("candidatePage.bulkSendMessage")}
                    </Button>
                    <Button variant="outlined" size="sm" onClick={onExport} loading={isXlsxLoading}>
                        {t("candidatePage.downloadXlsxSelected", { count: selectedCount })}
                    </Button>
                </HStack>
            </HStack>
        </Box>
    );
};

export default BulkActionsBar;
